function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class StickyAtcBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this._cacheElements();
    this._bindEvents();
  }

  _cacheElements() {
    this._productForm = document.querySelector('form.product-single__form .btn.add-to-cart');
    this._atcButton = this.querySelector('.btn.add-to-cart');
  }

  _bindEvents() {
    this._atcButton.addEventListener('click', this._addToCart.bind(this));
    window.addEventListener('scroll', debounce(this._handleScroll.bind(this), 100));
    document.addEventListener('CartDrawer:open', this._hide.bind(this));
  }

  _addToCart(e) {
    e.preventDefault();
    const atcButton = e.currentTarget;

    atcButton.classList.add('loading');
    atcButton.setAttribute('disabled', 'disabled');

    setTimeout(() => {
      atcButton.classList.remove('loading');
      atcButton.removeAttribute('disabled');
    }, 2000);
    this._productForm.click();
  }

  _handleScroll(e) {
    const yotpoWidget = document.querySelector('.yotpo-main-widget-layout');

    if (yotpoWidget) {
      if (window.scrollY >= yotpoWidget.scrollHeight) {
        this.classList.add('show');
      } else {
        this.classList.remove('show');
      }
    }
  }

  _hide() {
    this.classList.remove('show');
  }

  disconnectedCallback() {
    this._atcButton.removeEventListener('click', this._addToCart.bind(this));
    window.removeEventListener('scroll', debounce(this._handleScroll.bind(this), 100));
  }
}

if (!customElements.get('sticky-atc-bar')) {
  customElements.define('sticky-atc-bar', StickyAtcBar);
}
